module.exports = __webpack_public_path__ + "img/smart_tales_logo_basic.f44ce02c.png";